import type { Timestamp } from "@somewear/api";
import type { FileMetadataWithState } from "@somewear/model";

import type { IConversationEntity } from "../conversation/conversation.model";
import type { MessageOrFile } from "./messaging.model";
import { NEW_CONVERSATION_ID } from "./messagingSlice";

export function isVoiceFile(entity: MessageOrFile): entity is FileMetadataWithState {
	return (entity as FileMetadataWithState).isVoiceRecording;
}

export function isFile(entity: MessageOrFile): entity is FileMetadataWithState {
	return (entity as FileMetadataWithState).createdTimestamp !== undefined;
}

export function getMessageTimestamp(entity: MessageOrFile): Timestamp.AsObject {
	return isFile(entity) ? entity.createdTimestamp! : entity.timestamp!;
}

export function getMessageSenderId(entity: MessageOrFile): string {
	return isFile(entity) ? entity.userId : entity.senderId;
}

export function messageHasTimestamp(message?: MessageOrFile): boolean {
	return Boolean(message && getMessageTimestamp(message));
}

export function isNewConversation(conversation?: Pick<IConversationEntity, "id">): boolean {
	return conversation?.id === NEW_CONVERSATION_ID || conversation?.id === "tmp";
}

const VOICE_FILES_HIDDEN_KEY = "somewear_voice_log_hidden";

export function getVoiceFilesHidden(): boolean {
	return localStorage.getItem(VOICE_FILES_HIDDEN_KEY) !== null;
}

export function persistVoiceFilesHidden(hidden: boolean): void {
	if (hidden) {
		localStorage.setItem(VOICE_FILES_HIDDEN_KEY, "1");
	} else {
		localStorage.removeItem(VOICE_FILES_HIDDEN_KEY);
	}
}
